import { createFileRoute } from "@tanstack/react-router";
import { EntityFormPage } from "@/components/entity-page/EntityFormPage";
import CreateTranscriptionProviderForm from "@/components/CreateTranscriptionProviderForm";

export const Route = createFileRoute("/dashboard/settings/transcriptionProviders/new")({
  component: CreateTranscriptionProviderPage,
});

function CreateTranscriptionProviderPage() {
  return <CreateTranscriptionProviderPageComponent />;
}

// Exported for testing
export function CreateTranscriptionProviderPageComponent() {
  return (
    <EntityFormPage
      title="Create Transcription Provider"
      description="Add a new transcription provider to the catalog."
      backHref="/dashboard/settings/transcriptionProviders"
    >
      <CreateTranscriptionProviderForm />
    </EntityFormPage>
  );
}
